import { render, staticRenderFns } from "./Json.vue?vue&type=template&id=2ba55b60"
import script from "./Json.vue?vue&type=script&lang=ts"
export * from "./Json.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports